// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { isEmbeddedInAtlassian } from '@trello/browser';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';

// eslint-disable-next-line no-restricted-imports
import { Controller } from 'app/scripts/controller';
import { isShowingBoardViewSection } from 'app/scripts/controller/getCurrentBoardView';
import { Auth } from 'app/scripts/db/Auth';
import { l } from 'app/scripts/lib/localize';
import {
  getPermLevelAltTextForBoard,
  getPermLevelAltTextForTemplate,
  getPermLevelIconClassForBoard,
} from 'app/scripts/views/internal/BoardDisplayHelpers';
import { BoardHeaderPermissionsTemplate } from 'app/scripts/views/templates/BoardHeaderPermissionsTemplate';
import type { BoardView } from './BoardView';

export const permChange = function (this: BoardView, newPerm: string) {
  if (newPerm === 'none') {
    // TODO: Need to replace this with a navigate(...) call.
    Controller.memberHomePage();
  } else {
    // Non-board views and the powerups screen aren't re-rendered when
    // this.render() is called. This is a workaround to avoid a bug where
    // permissions were changing shortly after loading a board and the views
    // were disappearing.
    if (!isShowingBoardViewSection('board')) {
      this.render();
    }

    // If we can't edit the board, hide the card composer (if it's open)
    if (!this.model.editable()) {
      this.model.composer.save('vis', false);
    }
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const renderPermissionLevel = function (this: any) {
  // eslint-disable-next-line @trello/enforce-variable-case
  const $perm = $('#permission-level', this.$el);
  const data = {
    permIconClass: getPermLevelIconClassForBoard(this.model),
    permText: l(['board perms', this.model.getPermLevel(), 'name']),
    showText: !isEmbeddedInAtlassian(),
  };

  $perm.html(BoardHeaderPermissionsTemplate(data));

  if (this.model.isTemplate()) {
    $perm.attr('title', getPermLevelAltTextForTemplate(this.model));
  } else {
    $perm.attr('title', getPermLevelAltTextForBoard(this.model));
  }

  const canInvite = this.model.canInvite(Auth.me());
  $('.js-manage-board-members', this.$el).toggle(canInvite);

  return this;
};
